<template>
	<footer>
		<div class="container">
			<div v-for="(column, index) in footer" :key="index" class="content" :class="'footer-' + index">
				<h2 v-if="column.title">{{ column.title }}</h2>
				<ul>
					<template v-for="(link, linkIndex) in column.links">
						<template v-if="link.url == null">
							<li v-html="link.title" :key="linkIndex"></li>
						</template>
						<template v-else>
							<Link
								v-if="linkIndex != 'language'"
								:title="link.title"
								:url="link.url"
								:target="link.target"
								:image="link.image"
								:className="'footer ' + index + ' ' + link.class"
								:key="linkIndex"
							/>
							<LangLink
								v-else
								:link="link"
								:key="linkIndex"
								:className="'footer ' + index + ' ' + link.class"
							/>
						</template>
					</template>
				</ul>
			</div>
		</div>
		<div class="copyright-content">
			<div class="copyright" v-html="$t('Foot.copyright')"></div>
		</div>
	</footer>
</template>
<script>
import Link from '../partials/Link.vue'
import LangLink from '../partials/LangLink.vue'
export default {
	name: 'Foot',
	components: { Link, LangLink },
	computed: {
		footer() {
			return this.$t('Foot.links')
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer {
	background-color: $darkGrayTheme;
	padding: 0px;
}

h2 {
	color: $gray5Theme;
	font-size: 15px;
	margin-top: 4px;
	margin-bottom: 11px;
	padding-bottom: 8px;
	border-bottom: 1px solid $gray5Theme;
}

.container {
	@include flex-container(space-between, flex-start, flex-start, nowrap);
	margin: 0 auto;
	max-width: $innerWidth;
	padding: 0;
}

.content {
	padding: 18px 0 32px;
	flex-basis: 25%;

	li {
		@extend %lato;
		padding: 8px 0;
		font-size: 15px;
		color: $gray5Theme;

		a {
			color: $gray5Theme;
		}
	}
}

.footer-address {
	padding-left: 11px;

	li {
		margin-bottom: -11px;

		br {
			margin-bottom: 1px;
		}
	}
}

.copyright-content {
	background-color: $black;
}
.copyright {
	height: 52px;
	max-width: $innerWidth;
	margin: -4px auto;
	color: $gray;
	text-align: left;
	padding: 19px 0 5px;
	font-size: 13px;
}

@include collapsed {
	.container {
		padding: 0 10px;
	}

	.copyright-content {
		padding-left: 10px;
	}
}

@include mobile {
	.container {
		display: block;
		text-align: center;
	}

	.content {
		width: 100%;
		padding: 32px 0 0;

		h2 {
			text-align: center;
		}
	}

	.copyright {
		text-align: center;
	}
}
</style>
